var exports = {
  "N1": "ChannelHeader.module__headerContainer___VmFkRW",
  "dL": "ChannelHeader.module__headerWrapper___VmFkRW",
  "Hv": "ChannelHeader.module__headerWrapperCallActive___VmFkRW",
  "hE": "ChannelHeader.module__headerContainerCallActive___VmFkRW",
  "Pf": "ChannelHeader.module__callBannerRing___VmFkRW",
  "Ud": "ChannelHeader.module__headerLeftSection___VmFkRW",
  "Gv": "ChannelHeader.module__backButton___VmFkRW",
  "wK": "ChannelHeader.module__backButtonDesktop___VmFkRW" + " " + "ChannelHeader.module__backButton___VmFkRW",
  "j2": "ChannelHeader.module__backIcon___VmFkRW",
  "Ir": "ChannelHeader.module__backIconBold___VmFkRW" + " " + "ChannelHeader.module__backIcon___VmFkRW",
  "CY": "ChannelHeader.module__leftContentContainer___VmFkRW",
  "Bn": "ChannelHeader.module__voiceCallHeaderSupplement___VmFkRW",
  "BN": "ChannelHeader.module__mobileButton___VmFkRW",
  "Vt": "ChannelHeader.module__desktopButton___VmFkRW" + " " + "ChannelHeader.module__mobileButton___VmFkRW",
  "R3": "ChannelHeader.module__avatarWrapper___VmFkRW",
  "ax": "ChannelHeader.module__groupDmHeaderTrigger___VmFkRW",
  "_D": "ChannelHeader.module__groupDmHeaderInner___VmFkRW",
  "ab": "ChannelHeader.module__groupDmEditIcon___VmFkRW",
  "HA": "ChannelHeader.module__channelName___VmFkRW",
  "$7": "ChannelHeader.module__groupDmChannelName___VmFkRW",
  "kf": "ChannelHeader.module__dmNameWrapper___VmFkRW",
  "a1": "ChannelHeader.module__userTag___VmFkRW",
  "p": "ChannelHeader.module__channelIcon___VmFkRW",
  "ml": "ChannelHeader.module__caretRight___VmFkRW",
  "Nj": "ChannelHeader.module__channelInfoContainer___VmFkRW",
  "u8": "ChannelHeader.module__followButton___VmFkRW",
  "B6": "ChannelHeader.module__topicDivider___VmFkRW",
  "zm": "ChannelHeader.module__topicContainer___VmFkRW",
  "yu": "ChannelHeader.module__topicButton___VmFkRW",
  "Am": "ChannelHeader.module__topicButtonOverflow___VmFkRW",
  "lY": "ChannelHeader.module__headerRightSection___VmFkRW",
  "P0": "ChannelHeader.module__messageSearchFocusWrapper___VmFkRW",
  "bS": "ChannelHeader.module__headerContainerThreadPanelOpen___VmFkRW",
  "gb": "ChannelHeader.module__iconButton___VmFkRW",
  "f5": "ChannelHeader.module__iconButtonDefault___VmFkRW" + " " + "ChannelHeader.module__iconButton___VmFkRW",
  "vR": "ChannelHeader.module__iconButtonSelected___VmFkRW" + " " + "ChannelHeader.module__iconButton___VmFkRW",
  "rB": "ChannelHeader.module__updateIconButton___VmFkRW" + " " + "ChannelHeader.module__iconButton___VmFkRW",
  "l_": "ChannelHeader.module__updateIcon___VmFkRW",
  "IC": "ChannelHeader.module__iconButtonMobile___VmFkRW",
  "iA": "ChannelHeader.module__buttonIcon___VmFkRW",
  "qt": "ChannelHeader.module__buttonIconMobile___VmFkRW",
  "Dm": "ChannelHeader.module__iconButtonWrapper___VmFkRW",
  "W9": "ChannelHeader.module__unreadPinIndicator___VmFkRW",
};

module.exports = exports;
